<!-- 点众快应用订单 -->
<template>
<div>
	<div id="" :style="{'width':table_scroll_width + 'px',}">
	<div :style="{'width':body_width - 60 + 'px',}" style="position: sticky;left: 30px;z-index: 5;">
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 0 0 0;">
			<div v-if="role_control.includes(1)" class="screen-box">
				<div class="screen-label">订单日期</div>
				<a-range-picker style="width:280px;" @change="onChangeDate" :allowClear="false"
				:locale="locale" 
				:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]" />
			</div>
			<div v-else class="screen-box">
				<div class="screen-label">订单日期</div>
				<a-range-picker style="width:280px;" @change="onChangeDate" :allowClear="false"
				:locale="locale" 
				:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]" 
				:disabledDate="DateControl" />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">渠道号</div>
				<!-- @popupScroll="popupScrollG" -->
				<a-select
					style="min-width: 220px"
					placeholder="请选择推广媒体"
					:filter-option="filterOption"
					@change="handleChangeC"
					:getPopupContainer="getsPopupContainer" 
					showSearch
					allowClear
				  >
					<a-select-option v-for="(value,key) in channelData" :key="key" :value="key">
					  {{value}}
					</a-select-option>
				</a-select>
			</div>
			

			<div class="screen-box">
				<div class="screen-label">订单ID</div>
				<a-input v-model="r_order_id" allowClear placeholder="请输入" style="width: 300px;"  />
			</div>
			
			
			<a-button @click="searchButton('button')" :loading="search_button_loading" class="screen-box" type="primary" icon="search">搜索</a-button>
			<a-button @click="exportButton" type="primary" icon="download" class="screen-box" >导出</a-button>
		</div>
	</div>
	</div>
	
	<div>
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div   class="table-th-cell-sticky" style="display: flex;align-items: center;">
				<div class="table-th-cell"
				:style="{'width':rableTitle[0].width + 'px'}" >
					ID
				</div>
				<div class="table-th-cell"
				:style="{'width':rableTitle[1].width + 'px'}" >
					渠道号
				</div>
				<div class="table-th-cell"
				:style="{'width':rableTitle[2].width + 'px'}" >
					渠道名称
				</div>
				
			</div>
			<div v-for="(item,index) in rableTitle" :key="index" >
				<div v-if="index > 2" class="table-th-cell" 
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
				<!-- ID -->
				<div class="table-td-cell" :style="{'width':rableTitle[0].width + 'px'}">
					{{item.id}}
				</div>
				<!-- 渠道号 -->
				<div  class="table-td-cell" :style="{'width':rableTitle[1].width + 'px'}">
					{{item.dianz_channel_id}}
				</div>
				<!-- 渠道名称 -->
				<div  class="table-td-cell" :style="{'width':rableTitle[2].width + 'px'}">
					{{item.dianz_channel_name}}
				</div>
				
			</div>
			
			<!-- 优化师 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[3].width + 'px'}">
				{{item.dianz_account_name}}
			</div>
			<!-- 点众订单ID -->
			<div  class="table-td-cell" :style="{'width':rableTitle[4].width + 'px'}">
				{{item.order_id}}
			</div>
			<!-- 用户ID -->
			<div  class="table-td-cell" :style="{'width':rableTitle[5].width + 'px'}">
				{{item.user_id}}
			</div>
			<!-- 用户绑定时间 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[6].width + 'px'}">
				{{item.reg_time_bind}}
			</div>
			<!-- 支付方式 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[7].width + 'px'}">
				{{item.pay_type == 1?'支付宝':'微信'}}
			</div>
			<!-- 类型 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[8].width + 'px'}">
				{{item.type == 1?'书币':'会员'}}
			</div>
			<!-- 充值金额(元) -->
			<div  class="table-td-cell" :style="{'width':rableTitle[9].width + 'px'}">
				{{item.order_money}}
			</div>
			<!-- 下单时间 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[10].width + 'px'}">
				{{item.order_time}}
			</div>
			<!-- 书名 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[11].width + 'px'}">
				{{item.book_name}}
			</div>
			<!-- 新用户充值 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[12].width + 'px'}">
				{{item.is_new_back == 1?'是':'否'}}
			</div>
			
		</div>
		<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		
		<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': body_width - 60 + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		<!-- 分页 -->
		<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="body_width - 60"
		:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
		@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	</div>
	
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { putDataMenu, dzOrderList, dzChannelList, dzOrderExport} from '@/request/api'
export default {
	name: 'orderDZ_',
	components: {
		
	},
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			startTime: '2020-05-01', // 投放日期-开始时间
			endTime: '2022-06-30', // 投放日期-结束时间
			filterList: { // 搜索条件内容
				channel_id: {},
				gzh_id: {},
			}, 
			channelData: {}, // 渠道号
			
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID", width:80, type:"id", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"渠道号", width:160, type:"dianz_channel_id", },
				{title:"渠道名称", width:160, type:"dianz_channel_name", },
				{title:"优化师", width:100, type:"dianz_account_name", },
				{title:"点众订单ID", width:180, type:"order_id", },
				{title:"用户ID", width:120, type:"user_id", },
				{title:"用户绑定时间", width:150, type:"reg_time_bind", },
				{title:"支付方式", width:100, type:"pay_type", },
				{title:"类型", width:100, type:"type", },
				{title:"充值金额(元)", width:120, type:"order_money", },
				{title:"下单时间", width:160, type:"order_time", },
				{title:"书名", width:130, type:"book_name", },
				{title:"新用户充值", width:120, type:"is_new_back", },
			],
			tableShowData: [],
			table_scroll_width: 1600,
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			search_button_loading: false, // 搜索按钮的加载状态
			r_page: 1,
			table_total: 0,
			r_limit: 30,
			r_channel_info_id: "0", // 渠道号,
			r_order_id: "", // 订单ID
			
			r_channel_id: "", // 渠道id
			r_gzh_id: "", // 公众号id
			r_platform:"", // 推广媒体
			r_link_id: "", // 落地页ID
			r_creativeid: "", // 创意ID
			r_ad_id: "", // 计划ID(单元ID)
			r_has_report: undefined, // 是否回传
			r_is_today_order: undefined, // 是否为注册当天订单
			r_is_has_link: undefined, // 是否匹配落地页
			r_is_again: undefined, // 是否首充
			
			role_control: [], // 用户权限控制
		}
	},
	mounted(){
		let that = this
		
		that.search_button_loading = true
		
		that.body_width = document.body.clientWidth // 筛选条件大盒子的宽度
		
		let nn = 0
		that.rableTitle.forEach((res,index)=>{
			nn = nn + res.width
		})
		that.table_scroll_width = nn + 30
		
		setTimeout(()=>{
			// 给母页面的tab传递粘性定位用的参数
			that.$bus.$emit("stickyData", that.table_scroll_width);
		},300)
		
		
		// 修改母页面的tab选中状态
		// setTimeout(()=>{
			that.$bus.$emit("tabPath", that.$route.fullPath);
		// },100)
		
		// 获取7天前日期
		let date1 = new Date(new Date().getTime() - 604800000);
		let month1
		if(date1.getMonth() + 1 < 10){
			month1 = '0' + (date1.getMonth() + 1)
		}
		else {
			month1 = date1.getMonth() + 1
		}
		let day1
		if(date1.getDate() < 10){
			day1 = "0" + date1.getDate()
		}
		else {
			day1 = date1.getDate()
		}
		// that.startTime = date1.getFullYear() + "-" + month1 + "-" + day1
		
		// 获取当前日期
		let date2 = new Date();
		let month2
		if(date2.getMonth() + 1 < 10){
			month2 = '0' + (date2.getMonth() + 1)
		}
		else {
			month2 = date2.getMonth() + 1
		}
		let day2
		if(date2.getDate() < 10){
			day2 = "0" + date2.getDate()
		}
		else {
			day2 = date2.getDate()
		}
		// console.log("date2.getDate();",date2.getDate())
		that.endTime = date2.getFullYear() + "-" + month2 + "-" + day2;
		// 默认获取1天的日期范围。然后因为非管理员只能看今天和昨天的数据，所以这里的开始时间要这么配
		that.startTime = date2.getFullYear() + "-" + month2 + "-" + day2;
		
		// 获取角色权限
		that.role_control = JSON.parse(localStorage.getItem("role_limits"))
		
		dzChannelList().then(res=>{
			console.log('渠道号',res);
			that.channelData = res.data.data.list
		})
		
		putDataMenu().then(res=>{
			console.log('putDataMenu',res)
			that.filterList = res.data.data.filter
			
			
			that.is_admin = res.data.data.is_admin
			
			// 搜索
			that.searchButton()
			
			
		})
	},
	methods:{
		// 日期选择
		onChangeDate(date, dateString) {
			console.log(date, dateString);
			this.startTime = dateString[0]
			this.endTime = dateString[1]
		},
		// 日期范围控制，根据权限来
		DateControl(current){
			// 只能看今天和昨天的日期
			return current && current > moment().endOf('day') || current < moment().subtract(2,"days")
		},
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		
		handleChangeC(e){ // 渠道号
			console.log(e);
			this.r_channel_info_id = e
			
		},
		
		// 搜索
		searchButton(type){
			let that = this
			that.search_button_loading = true
			
			// 点击按钮进行条件搜索的时候，要把页数变成1，否则相关内容可能搜索不出来。
			if(type == 'button'){
				that.r_page = 1
			}
			
			// 转成时间戳
			let date_s = new Date(that.startTime);
			let date_e = new Date(that.endTime);
			let r_data = {
				export: 0,
				limit: that.r_limit,
				page: that.r_page,
				start_date: date_s.getTime()/1000,
				end_date: date_e.getTime()/1000,
				order_id: that.r_order_id,
				channel_info_id: that.r_channel_info_id,
			}
			if(type != '导出'){
				dzOrderList(r_data).then(res=>{
					console.log('搜索',res);
					that.search_button_loading = false
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
						that.$message.success('搜索成功');
						that.table_total = res.data.data.total
						that.tableShowData = res.data.data.data
					}
					else {
						if(res.data.code == 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
					}
				})
			}
			else if(type == '导出'){
				r_data.export = 1
				delete r_data.page
				delete r_data.limit
				dzOrderExport(r_data).then(res=>{
					console.log("导出测试",res);
					that.search_button_loading = false
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){ 
						
						that.$message.success(res.data.msg || "导出成功");
						
					}
					else {
						
						if(res.data.code == 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
						
					}
				})
			}
		},
		// 分页的页数变化
		paginationChange(e){
			console.log(e)
			this.r_page = e
			this.searchButton()
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
		
		// 导出
		exportButton(){
			let that = this
			// 转成时间戳
			// let date_s = new Date(that.startTime);
			// let date_e = new Date(that.endTime);
			// let r_url = `${that.$http.excel_url}api/down/dz-order-report?export=1&start_date=${date_s.getTime()/1000}&end_date=${date_e.getTime()/1000}&limit=10000&page=1&channel_info_id=${that.r_channel_info_id}`
			
			// if(that.r_order_id){
			// 	r_url = r_url + `&order_id=${that.r_order_id}`
			// }
			
			that.searchButton('导出')
			// console.log("r_url",r_url);
			// window.open(r_url);
		},
	},
}
</script>

<style scoped>
.class-title {
	width: 100px;
}

.table-td-cell {
	font-size: 13px;
}
</style>